//  For each product on the page
document.querySelectorAll('.product').forEach(section => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    const productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        on: {
            slideChange: function () {
                updatesSlideStatus(this.activeIndex);
            }
        }
    });

    const thumbSwiper = new Swiper(section.querySelector(".productVisualThumbsSwiper"), {
        slidesPerView: 3,
        spaceBetween: 16,
        direction: 'horizontal',
        breakpoints: {
            801: {
                direction: 'vertical',
                slidesPerView: 6,
            }
        },
        navigation: {
            prevEl: section.querySelector(".productVisualThumbsPrev"),
            nextEl: section.querySelector(".productVisualThumbsNext"),
        },
        on: {
            slideChange: function () {
                productSwiper.slideTo(this.activeIndex);
                updatesSlideStatus(this.activeIndex);
            }
        }
    });

    function updatesSlideStatus(index) {
        const slides = section.querySelector('.productVisualThumbsSwiper').querySelectorAll('.swiper-slide');
        slides.forEach(slide => slide.classList.remove('active'));
        slides[index].classList.add('active');
        // pause all videos
        section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
            element.pause();
        });
    }

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // change slide on thumbnail click
    section.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    /**************
     General
     ***************/

    // use swipers height to set max-height on content
    document.addEventListener('DOMContentLoaded', () => {
        if (window.innerWidth <= 800) return;
        const height = section.querySelector('.productVisual').offsetHeight;
        section.querySelector('.productContentInner').style.maxHeight = `${height}px`;
    })

    // truncated text toggle
    section.querySelectorAll('.productDescriptionTruncatedButton')?.forEach(button => {
        button.addEventListener('click', function () {
            this.closest('.productDescription').classList.add('active');
        })
    })

    // sticky atc
    const hasSticky = !!section.querySelector(".productSticky");
    window.addEventListener('scroll', () => {
        if (section.getBoundingClientRect().bottom <= 0) {
            // show when past pdp top and hide when footer shows up
            document.querySelector('#footer').getBoundingClientRect().top < window.innerHeight
                ? section.querySelector(".productSticky").classList.remove('active')
                : section.querySelector(".productSticky").classList.add('active');
        } else {
            section.querySelector(".productSticky").classList.remove('active');
        }
    })

    /**************
     Update Product
     ***************/

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct().catch(err => console.error(err));
        });
    })

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productFormOptionsItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelectorAll(".productATC").forEach(button => button.disabled = true);
            section.querySelectorAll(".productATCText").forEach(button => button.textContent = "Not Available");
            section.querySelectorAll('.productStickyATC').forEach(button => button.disabled = true);
            section.querySelectorAll(".productStickyATCText").forEach(button => button.textContent = "Not Available");
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Price
         ***************/

            // update price
        const compareEls = section.querySelectorAll(".productPriceCompare");
        const realEls = section.querySelectorAll(".productPriceReal");

        if (activeVariant.compare_at_price > activeVariant.price) {
            compareEls.forEach(el => el.textContent = price(activeVariant.compare_at_price))
        }
        realEls.forEach(el => el.textContent = price(activeVariant.price))

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelectorAll(".productATC").forEach(button => button.disabled = false);
            section.querySelectorAll(".productATCText,.productStickyATCText").forEach(button => button.textContent = "Add To Cart");
            section.querySelectorAll(".productATC.yellow .productATCText").forEach(button => button.textContent = "Buy Now");
            section.querySelectorAll(".productStickyATC.yellow .productStickyATCText").forEach(button => button.textContent = `Buy Now ${price(activeVariant.price, true)}`);
        } else {
            section.querySelectorAll(".productATC,.productStickyATC").forEach(button => button.disabled = true);
            section.querySelectorAll(".productATCText, .productStickyATCText").forEach(button => button.textContent = "Sold Out");
            // return;
        }

        // update url with variant id so the selected options are maintained on refresh, but not on the initial load
        if (product.variants[0].id !== activeVariant.id) {
            let url = new URL(window.location.href);
            url.searchParams.set("variant", activeVariant.id);
            window.history.replaceState({}, "", url);
        }
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(err => console.error(err));

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productQuantityControlsBtn.minus")?.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productQuantityControlsValue").textContent = quantity;
        updateProduct().catch(err => console.error(err));
    });

    // plus
    section.querySelector(".productQuantityControlsBtn.plus")?.addEventListener("click", function () {
        quantity++;
        section.querySelector(".productQuantityControlsValue").textContent = quantity;
        updateProduct().catch(err => console.error(err));
    });


    /**************
     Product ATC
     ***************/

    // async function addToCart(buyNow = false) {
    //
    //     // add loading animation to both buttons
    //     section.querySelectorAll(".productATC,.productStickyATC").forEach(el => el.classList.add("loading"));
    //
    //     let formData = {
    //         items: [{
    //             quantity: quantity,
    //             id: activeVariant.id,
    //         }]
    //     };
    //
    //     // add product
    //     await addProduct(formData);
    //
    //     // remove loading animation
    //     section.querySelectorAll(".productATC,.productStickyATC").forEach(el => el.classList.remove("loading"));
    //
    //     if (buyNow) {
    //         // go to checkout
    //         window.location.href = `${Shopify.routes.root}checkout`;
    //     } else {
    //         // open cart
    //         await openCart();
    //     }
    // }

    section.querySelectorAll(".productATC,.productStickyATC").forEach(el => el.addEventListener("click", async function () {
        // addToCart(this.classList.contains('yellow')).catch(err => console.error(err));

        // add loading animation to both buttons
        this.classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        if (this.classList.contains('yellow')) {
            // go to checkout
            window.location.href = `${Shopify.routes.root}checkout`;
        } else {
            // open cart
            await openCart();
        }
    }));

    /** Block - Dropdown **/

    // setup dropdowns
    section.querySelectorAll(".productDropdownToggle").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });
});